<!--
 * @Description: 出入厂检查-修改
 * @Author: fanwenjing
 * @LastEditors: fanwenjing
 * @Date: 2021-05-26 19:55:27
 * @LastEditTime: 2021-05-26 19:56:32
-->

<template>
  <add-or-update pageType="update" />
</template>
<script>
import addOrUpdate from "./components/addOrUpdate";

export default {
  name: "inspectionUpdate",
  components: { addOrUpdate }
};
</script>
